import {
  GET_COURSES,
  GET_COURSE,
  GET_COURSE_VIDEO,
  GET_CONTENT,
  CREATE_COURSE,
  COURSE_FAIL,
  CONTENT_ERROR,
  CLEAR_CONTENT,
  ADD_COURSE_COMMENT,
  DELETE_COURSE_COMMENT,
} from "../actions/types";

const initialState = {
  courses: [],
  course: {},
  coursevideo: {},
  loading: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_COURSES:
      return {
        ...state,
        courses: payload,
        loading: false,
      };
    case GET_COURSE:
      return {
        ...state,
        course: payload,
        coursevideo: payload.coursesections.map((x) => x.videos[0]).pop(),
        loading: false,
      };
    case ADD_COURSE_COMMENT:
      return {
        ...state,
        course: payload,
        loading: false,
      };
    case DELETE_COURSE_COMMENT:
      return {
        ...state,
        course: payload,
        loading: false,
      };
    case GET_COURSE_VIDEO:
      return {
        ...state,
        coursevideo: payload,
        loading: false,
      };
    case GET_CONTENT:
      return {
        ...state,
        course: payload,
        loading: false,
      };
    case CREATE_COURSE:
      return {
        ...state,
        course: payload,
        loading: false,
      };
    case COURSE_FAIL:
      return {
        ...state,
        course: {},
        courses: [],
        coursevideo: {},
        loading: true,
      };
    case CLEAR_CONTENT:
      return {
        ...state,
        course: {},
        courses: [],
        coursevideo: {},
        loading: true,
      };
    case CONTENT_ERROR:
      return {
        ...state,
        course: {},
        courses: [],
        loading: true,
      };
    default:
      return state;
  }
}
